module.exports = __webpack_public_path__ + "media/header-ar.95541e46.mp4";